"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Modal = _interopRequireWildcard(require("@kiwicom/orbit-components/lib/Modal"));
var _Illustration2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _cookies = require("@kiwicom/cookies");
var _LanguageSelect = _interopRequireDefault(require("./components/LanguageSelect"));
var _CurrencySelect = _interopRequireDefault(require("./components/CurrencySelect"));
var _context = require("../../services/intl/context");
var _context2 = require("../../services/currency/context");
var _context3 = require("../../services/auth/context");
var _updateLocale = _interopRequireDefault(require("../../graphql/account/queries/updateLocale"));
var _updateLanguagePath = _interopRequireDefault(require("./updateLanguagePath"));
var _context4 = require("../TopNav/services/context");
var _context5 = require("../../services/log/context");
var _events = require("../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _FormattedMessage2, _Illustration, _ModalFooter;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const RegionalSettings = ({
  onClose,
  brandLanguage
}) => {
  const {
    language
  } = (0, _context.useIntl)();
  const intl = (0, _reactIntl.useIntl)();
  const {
    onSaveRegionalSettings
  } = (0, _context4.useNavConfig)();
  const {
    onChange,
    currency
  } = (0, _context2.useCurrency)();
  const {
    auth
  } = (0, _context3.useAuth)();
  const {
    log
  } = (0, _context5.useLog)();
  const isSignedIn = (auth === null || auth === void 0 ? void 0 : auth.type) === "user";
  const [languageId, setLanguage] = React.useState(language.id);
  const [currencyId, setCurrency] = React.useState(currency.id);
  const languageMap = brandLanguage.languages;
  React.useEffect(() => {
    setLanguage(language.id);
    setCurrency(currency.id);
  }, [language.id, currency.id]);
  const onSubmit = async e => {
    e.preventDefault();
    if ((auth === null || auth === void 0 ? void 0 : auth.type) === "user") {
      const languageIso = languageMap[languageId].iso;
      try {
        await (0, _updateLocale.default)(auth.token, {
          currency: currencyId.toUpperCase(),
          language: {
            code: languageIso
          }
        });
      } catch (err) {
        log(_events.REGIONAL_SETTINGS_ERROR, {
          error: String(err),
          currency: currencyId,
          language: languageIso
        });
      }
    }
    (0, _cookies.save)(_cookies.Cookie.LANGUAGE, languageId);
    (0, _cookies.save)(_cookies.Cookie.CURRENCY, currencyId);
    onChange(currencyId);

    // FE Booking uses custom onSaveLang function to persist form data
    // on page refresh
    if (onSaveRegionalSettings) {
      onSaveRegionalSettings({
        languageId,
        currencyId
      });
      onClose();
      return;
    }
    (0, _updateLanguagePath.default)(languageId);
    onClose();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default, {
    size: "small",
    onClose: onClose,
    dataTest: "RegionalSettingsModal",
    labelClose: intl.formatMessage({
      id: "orbit.button_close"
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ModalHeader, {
      title: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.regional_settings_modal.title"
      })),
      description: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: isSignedIn ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.regional_settings_modal.description_signed_in",
          values: {
            strong: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
              children: text
            })
          }
        }) : _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.regional_settings_modal.description"
        }))
      }),
      illustration: _Illustration || (_Illustration = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration2.default, {
        name: "Tours",
        size: "extraSmall"
      }))
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
      onSubmit: onSubmit,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ModalSection, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LanguageSelect.default, {
            setLanguage: setLanguage,
            languageId: languageId,
            brandLanguage: brandLanguage
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrencySelect.default, {
            setCurrency: setCurrency,
            currencyId: currencyId
          })]
        })
      }), _ModalFooter || (_ModalFooter = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ModalFooter, {
        flex: "1 0 100%",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          submit: true,
          fullWidth: true,
          dataTest: "SubmitRegionalSettingsButton",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.regional_settings_modal.footer.save"
          })
        })
      }))]
    })]
  });
};
var _default = RegionalSettings;
exports.default = _default;